export default __webpack_public_path__ + "static/media/the_minx.f5ccfc3b.JPG";